/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MediaBaseService } from '../media-base-service';
import { MediaApiConfiguration } from '../media-api-configuration';
import { MediaStrictHttpResponse } from '../media-strict-http-response';

import { KeyValueGuidModel } from '../models/key-value-guid-model';
import { KeyValueModel } from '../models/key-value-model';
import { masterDataCategoryListGet$Json } from '../fn/master-data/master-data-category-list-get-json';
import { MasterDataCategoryListGet$Json$Params } from '../fn/master-data/master-data-category-list-get-json';
import { masterDataCategoryListGet$Plain } from '../fn/master-data/master-data-category-list-get-plain';
import { MasterDataCategoryListGet$Plain$Params } from '../fn/master-data/master-data-category-list-get-plain';
import { masterDataPublisherListGet$Json } from '../fn/master-data/master-data-publisher-list-get-json';
import { MasterDataPublisherListGet$Json$Params } from '../fn/master-data/master-data-publisher-list-get-json';
import { masterDataPublisherListGet$Plain } from '../fn/master-data/master-data-publisher-list-get-plain';
import { MasterDataPublisherListGet$Plain$Params } from '../fn/master-data/master-data-publisher-list-get-plain';
import { masterDataSupportedLanguageTypesGet$Json } from '../fn/master-data/master-data-supported-language-types-get-json';
import { MasterDataSupportedLanguageTypesGet$Json$Params } from '../fn/master-data/master-data-supported-language-types-get-json';
import { masterDataSupportedLanguageTypesGet$Plain } from '../fn/master-data/master-data-supported-language-types-get-plain';
import { MasterDataSupportedLanguageTypesGet$Plain$Params } from '../fn/master-data/master-data-supported-language-types-get-plain';

@Injectable({ providedIn: 'root' })
export class MediaMasterDataService extends MediaBaseService {
  constructor(config: MediaApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `masterDataSupportedLanguageTypesGet()` */
  static readonly MasterDataSupportedLanguageTypesGetPath = '/MasterData/SupportedLanguageTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataSupportedLanguageTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataSupportedLanguageTypesGet$Plain$Response(params?: MasterDataSupportedLanguageTypesGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataSupportedLanguageTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataSupportedLanguageTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataSupportedLanguageTypesGet$Plain(params?: MasterDataSupportedLanguageTypesGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataSupportedLanguageTypesGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataSupportedLanguageTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataSupportedLanguageTypesGet$Json$Response(params?: MasterDataSupportedLanguageTypesGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataSupportedLanguageTypesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataSupportedLanguageTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataSupportedLanguageTypesGet$Json(params?: MasterDataSupportedLanguageTypesGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataSupportedLanguageTypesGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPublisherListGet()` */
  static readonly MasterDataPublisherListGetPath = '/MasterData/PublisherList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPublisherListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPublisherListGet$Plain$Response(params?: MasterDataPublisherListGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return masterDataPublisherListGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPublisherListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPublisherListGet$Plain(params?: MasterDataPublisherListGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.masterDataPublisherListGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPublisherListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPublisherListGet$Json$Response(params?: MasterDataPublisherListGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return masterDataPublisherListGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPublisherListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPublisherListGet$Json(params?: MasterDataPublisherListGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.masterDataPublisherListGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

  /** Path part for operation `masterDataCategoryListGet()` */
  static readonly MasterDataCategoryListGetPath = '/MasterData/CategoryList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataCategoryListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataCategoryListGet$Plain$Response(params?: MasterDataCategoryListGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return masterDataCategoryListGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataCategoryListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataCategoryListGet$Plain(params?: MasterDataCategoryListGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.masterDataCategoryListGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataCategoryListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataCategoryListGet$Json$Response(params?: MasterDataCategoryListGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return masterDataCategoryListGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataCategoryListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataCategoryListGet$Json(params?: MasterDataCategoryListGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.masterDataCategoryListGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

}
